// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import { ColourPalette } from "@esenda/core-ui/constants";

const lightTheme = {
    dark: false,
    colors: {
        surface: ColourPalette.WHITE,
        primary: ColourPalette.PRIMARY_400,
        secondary: ColourPalette.CYAN,
        tertiary: ColourPalette.MAGENTA,
        white: ColourPalette.WHITE,
        dark: ColourPalette.INK,
        "gradient-dark": ColourPalette.GRADIENT_DARK,
        "slate-grey": ColourPalette.SLATE_GREY,
        background: ColourPalette.APP_BACKGROUND,
        success: ColourPalette.SUCCESS_500,
        warning: ColourPalette.WARNING_50,
        error: ColourPalette.RED_500,
        disabled: ColourPalette.DISABLED_BG,
        "border-grey": ColourPalette.BORDER_GREY,
    },
};

const vuetify = createVuetify({
    theme: {
        defaultTheme: "lightTheme",
        themes: {
            lightTheme,
        },
    },
    icons: {
        defaultSet: "mdi",
        aliases,
        sets: {
            mdi,
        },
    },
    defaults: {
        VTooltip: {
            color: "surface-variant",
            location: "top",
            openDelay: 300,
        },
        VAutocomplete: {
            menuProps: {
                maxWidth: 0,
            },
        },
        VSelect: {
            menuProps: {
                maxWidth: 0,
            },
        },
    },
});

export default vuetify;
